import React from 'react'
import styled from 'styled-components'
import { Container, Row, Col } from 'components/Grid'
import { StyledMarkdown as Markdown, CButton, Section } from 'components/Common'
import _unescape from 'lodash/unescape'

export const StyledMarkdown = styled(Markdown)`
  ul > li {
    list-style: square !important;
    &:before {
      content: none;
    }
  }
`

function Content({ blok, ...props }) {
  return (
    <Section paddingBottom={270}>
      <Container>
        <Row>
          <Col width={[1]}>
            <StyledMarkdown source={_unescape(blok.content)} />
            <CButton onClick={props.moveToApplication} type="secondary" withArrow size="big" css={'margin: 113px auto 0; font-size: 16px;'}>Apply for this role</CButton>
          </Col>
        </Row>
      </Container>
    </Section>
  )
}

export default Content
